<template>
<span v-show="campo.visivelPadrao">
<b-row sm="12" md="12" v-if="campo.tpDado == tipoEnum.NUMERICO && campo.lista == false">

    <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
        <label :class="campo.obrigatorio ? `required` : ``">
            {{campo.nomeCampo}}
        <i
            v-b-modal
            v-if="isTextoAjuda"
            class="fas fa-info-circle fa-12x text-info"
            variant="info"
            v-b-popover.hover.top="`${campo.textoAjuda}`"
            tabindex="-1"
        ></i>
        </label>
        <b-form-group v-slot="{ ariaDescribedby }">
          <input
              :id="id"
              :name="id"
              v-if="campo.tpDado == tipoEnum.NUMERICO && campo.lista == false"
              class="form-control"
              :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
              v-model="campo.valorFormatado"
              :disabled="passo.disabled"
              :readonly="!campo.editavel"
              v-mask="campo.editavel ? ((campo.formato) ? (campo.cdCampoGuia == 17 ? ['(##) ####-####', '(##) #####-####'] : campo.formato) : undefined) : undefined"
              @blur="preencherComZeros(); blurInput(validador)"
              @input="campo.valorFormatado = campo.valorFormatado.toUpperCase() ;inputInput(validador)"
          />
          <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
        </b-form-group>
    </b-col>
</b-row>
<b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.DECIMAL && campo.lista == false">
    <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
        <label :class="campo.obrigatorio ? `required` : ``">
            {{campo.nomeCampo}}
        <i
            v-b-modal
            v-if="isTextoAjuda"
            class="fas fa-info-circle fa-12x text-info"
            variant="info"
            v-b-popover.hover.top="`${campo.textoAjuda}`"
            tabindex="-1"
        ></i>
        </label>  
        <b-form-group v-slot="{ ariaDescribedby }">
          <money
            :id="id"
            :name="id"
            v-if="campo.tpDado == tipoEnum.DECIMAL && campo.lista == false"
            class="form-control text-right"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            placeholder="0,00"
            v-bind="money"
            v-model="valorTemporario.valorTemporario"
            :disabled="passo.disabled"
            :readonly="!campo.editavel"
            :maxlength="Math.max((campo.tamMaximo || 0), 3) + (Math.floor(Math.max((campo.tamMaximo || 0), 3) / 3) + 3)"
            @blur.native="blurInput(validador)"
            @input.native="campo.valorFormatado = valorTemporario.valorTemporario.toFixed(2); inputInput(validador)"
            @keydown.native="retirarMenos($event)"
          ></money>
          <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
        </b-form-group>
    </b-col>
</b-row>      
<b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.TEXTO && campo.lista == false">
    <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
        <label :class="campo.obrigatorio ? `required` : ``">
            {{campo.nomeCampo}}
        <i
            v-b-modal
            v-if="isTextoAjuda"
            class="fas fa-info-circle fa-12x text-info"
            variant="info"
            v-b-popover.hover.top="`${campo.textoAjuda}`"
            tabindex="-1"
        ></i>
        </label>
        <b-form-group v-slot="{ ariaDescribedby }">
          <textarea
            :id="id"
            :name="id"
            v-if="campo.tpDado == tipoEnum.TEXTO && campo.lista == false && campo.textoLongo == true"
            class="form-control"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            v-model="campo.valorFormatado"
            :disabled="passo.disabled"
            :readonly="!campo.editavel"
            :maxlength="campo.tamMaximo"
            @blur="blurInput(validador)"
            @input="inputInput(validador)"
          ></textarea>
          <input
            :id="id"
            :name="id"
            v-if="campo.tpDado == tipoEnum.TEXTO && campo.lista == false && campo.textoLongo == false"
            class="form-control"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            v-model="campo.valorFormatado"
            :disabled="passo.disabled"
            :readonly="!campo.editavel"
            :maxlength="campo.tamMaximo"
            @blur="blurInput(validador)"
            @input="inputInput(validador)"
          />
          <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
        </b-form-group>
    </b-col>
</b-row>
<b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.PERCENTUAL && campo.lista == false">
    <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
        <label :class="campo.obrigatorio ? `required` : ``">
            {{campo.nomeCampo}}
        <i
            v-b-modal
            v-if="isTextoAjuda"
            class="fas fa-info-circle fa-12x text-info"
            variant="info"
            v-b-popover.hover.top="`${campo.textoAjuda}`"
            tabindex="-1"
        ></i>
        </label>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-input-group append="%">    
          <input
            :id="id"
            :name="id"
            v-if="campo.tpDado == tipoEnum.PERCENTUAL && campo.lista == false"
            class="form-control text-right"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            v-model="campo.valorFormatado"
            v-mask="mascaraPercentual"
            :disabled="passo.disabled"
            :readonly="!campo.editavel"
            @blur="blurInput(validador)"
            @input="inputInput(validador)"
          />
          </b-input-group>
          <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
        </b-form-group>
    </b-col>
</b-row>
<b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.DATA && campo.lista == false">
    <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
        <label :class="campo.obrigatorio ? `required` : ``">
            {{campo.nomeCampo}}
        <i
            v-b-modal
            v-if="isTextoAjuda"
            class="fas fa-info-circle fa-12x text-info"
            variant="info"
            v-b-popover.hover.top="`${campo.textoAjuda}`"
            tabindex="-1"
        ></i>
        </label>
        <b-form-group v-slot="{ ariaDescribedby }">
          <datePicker
            :id="id"
            :name="id"
            v-if="campo.tpDado == tipoEnum.DATA && campo.lista == false && campo.editavel == true"
            class="form-control"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            v-model="campo.valorFormatado"
            :disabled="passo.disabled"
            :config="options2"
            @blur.native="blurInput(validador)"
            @input.native="inputInput(validador)"
            @dp-change="tratarDataVazia"
          ></datePicker>
          <input
            :id="id"
            :name="id"
            v-else-if="campo.tpDado == tipoEnum.DATA && campo.lista == false && campo.editavel == false"
            class="form-control text-left"
            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
            v-model="campo.valorFormatado"
            :readonly="true"
            @blur="blurInput(validador)"
            @input="inputInput(validador)"
          />
          <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
        </b-form-group>
    </b-col>
</b-row>
        <b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.NUMERICO && campo.lista == true">
            <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
                <label :class="campo.obrigatorio ? `required` : ``">
                    {{campo.nomeCampo}}
                <i
                    v-b-modal
                    v-if="isTextoAjuda"
                    class="fas fa-info-circle fa-12x text-info"
                    variant="info"
                    v-b-popover.hover.top="`${campo.textoAjuda}`"
                    tabindex="-1"
                ></i>
                </label>                
                <b-form-group v-slot="{ ariaDescribedby }">
                        <multiselect
                            :id="id"
                            :name="id"
                            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"                            
                            v-model="valorMultselect"
                            :options="campo.lstItem"
                            label="label"
                            track-by="codigo"
                            :aria-describedby="ariaDescribedby"
                            placeholder="Digite e selecione a opção desejada"
                            selectLabel=""
                            selectGroupLabel=""
                            selectedLabel="Selecionado"
                            deselectLabel=""
                            deselectGroupLabel=""
                            :allow-empty="false"
                            @input="campo.valorFormatado = valorMultselect.codigo;eventoInputComboBox();alterarAtributosFilho()"
                            :disabled="passo.disabled || !campo.editavel"
                            @select="blurInput(validador)"
                            @close="blurInput(validador)"
                            >
                            <template #noResult>
                                Nenhuma opção encontrada. Tente outro termo.
                            </template>
                        </multiselect>                        
                        <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row sm="12" md="12" v-else-if="campo.tpDado == tipoEnum.TEXTO && campo.lista == true">
            <b-col sm="12" :md="larguraColuna" :lg="larguraColuna">
                <label :class="campo.obrigatorio ? `required` : ``">
                    {{campo.nomeCampo}}
                <i
                    v-b-modal
                    v-if="isTextoAjuda"
                    class="fas fa-info-circle fa-12x text-info"
                    variant="info"
                    v-b-popover.hover.top="`${campo.textoAjuda}`"
                    tabindex="-1"
                ></i>
                </label>
                <b-form-group v-slot="{ ariaDescribedby }"  >                     
                        <multiselect
                            :id="id"
                            :name="id"
                            :class="(isListaDeErros) ? 'border-input-error' : 'border-input-normal'"
                            v-model="valorMultselect"
                            :options="campo.lstItem"
                            label="label"
                            track-by="codigo"
                            :aria-describedby="ariaDescribedby"
                            placeholder="Digite e selecione a opção desejada"
                            selectLabel=""
                            selectGroupLabel=""
                            selectedLabel="Selecionado"
                            deselectLabel=""
                            deselectGroupLabel=""
                            :disabled="passo.disabled || !campo.editavel"
                            :allow-empty="false"
                            @input="campo.valorFormatado = valorMultselect.codigo;eventoInputComboBox();alterarAtributosFilho()"
                            @select="blurInput(validador)"
                            @close="blurInput(validador)"
                            >
                            <template #noResult>
                                Nenhuma opção encontrada. Tente outro termo.
                            </template>
                        </multiselect>
                        <InputTipoDadoErros :validador="validador" :lstErros="campo.lstErros"/>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-else-if="situacaoInexistente()">
            <b-col>
            </b-col>
        </b-row>
</span>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import Multiselect from 'vue-multiselect'
import InputTipoDadoErros from './InputTipoDadoErros'
import mascarasMixin from '@/mixins/mascarasMixin'
import totalizadorMixin from '@/mixins/totalizadorMixin'
import vmoneyMixin from '@/mixins/vmoneyMixin'
import _ from 'lodash'

export default {
    name: 'InputTipoDado',
    mixins: [mascarasMixin, totalizadorMixin, vmoneyMixin],
    components: {
        datePicker,
        Multiselect,
        InputTipoDadoErros,
    },
    props: {
        id: String,
        passos: Array,
        indicePassos: Number,
        larguraColuna: Number,
        idx: Number,
        campo: Object,
        passo: Object,
        lstCampos: Array,
        v: Object
    },
    data() {
        return {
            elementoFilho: null,
            elementoFilhoOriginal: null,
            campoLista: {
                valorFormatado: ''
            },
            tipoEnum: {
                NUMERICO: 1,
                DECIMAL: 2,
                TEXTO: 3,
                DATA: 4,
                PERCENTUAL: 5,
                ALFANUMERICO: 6
            },

            codCampoEnum: {
                TOTALIZADOR: 13
            },

            // DECIMAL
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },
            options2: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                showClear: true,
                showClose: true,
                locale: 'pt-br',
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
                indiceValidadorFilho: {},

            mascaraTipoNumerico: '',
            valorMultselect: '',
            
            valorTemporario: {
                valorTemporario: ''
            },

            multiplasMascaras: null

        }
    },
    created() {
        if(this.campo.idParametCampoGuiaCruzada != null)
            this.buscarFilho()

        // Seta a mascara do campos numerico, caso exista ainda.
        if(this.campo.tpDado == this.tipoEnum.NUMERICO) {            
            if(this.campo.formato.length == 0) {
                this.campo.formato = this.mascaraTipoNumerico.padEnd(this.campo.tamMaximo, '#')
            }
        }
        
        // configura o campo como totalizador
        if(this.campo.cdCampoGuia == this.codCampoEnum.TOTALIZADOR) {
            this.setupTotalizador(this.valorTemporario, this.lstCampos)
        }

        // Tratamento do multiselect
        if((this.campo.tpDado == this.tipoEnum.NUMERICO || this.campo.tpDado == this.tipoEnum.TEXTO) && this.campo.lista == true) {
            this.valorMultselect = this.campo.lstItem.find((e) => (this.campo.valorFormatado == e.codigo))
        }
    },
    mounted() {
        if(this.campo.tpDado == this.tipoEnum.DECIMAL) {
            this.valorTemporario.valorTemporario = this.campo.valorFormatado
        }

        this.setMultiplasMascaras()

        this.validador.$reset()
    },
    computed: {
        calculaLargura() {
            return this.larguraColuna // == 6 ? 12 : this.larguraColuna
        },
        idModal() {
            return 'modal_'+this.id
        },
        isTextoAjuda() {
            return ((this.campo?.textoAjuda?.length || 0) > 0)
        },
        itemListaPorValorSelecionado() {
             return this.campo.lstItem.find((e) => (e.codigo == this.campo.valorFormatado)) || {formato: ''}
        },
        isListaDeErros() {
            return this.campo?.lstErros?.length > 0
        },
        isListaDeErrosFilho() {
            return this.elementoFilho?.lstErros?.length > 0
        },
        validador() {
            return this.v?.passos?.$each[this.indicePassos]?.data?.lstCampos?.$each[this.idx]
        },
        validadorFilho() {
            return this.v?.passos?.$each[this.indicePassos]?.data?.lstCampos?.$each[this.indiceValidadorFilho]
        }        
    },
    methods: {
        tratarDataVazia() {
            if(this.campo.valorFormatado==null) {
                this.inputInput(this.validador)
            }
        },
        alterarAtributosFilho() {
            if(this.elementoFilho) {

                let campoFilho = this.campo.lstItem.find((e) => (e.codigo == this.campo.valorFormatado))

                    if(campoFilho.redirecionamento != null) {
                        this.campo.valorFormatado = this.valorMultselect = ''

                        // Volta os atributos originais da tela incial
                        this.elementoFilho.label = this.elementoFilhoOriginal.label
                        this.elementoFilho.nomeCampo = this.elementoFilhoOriginal.nomeCampo
                        this.elementoFilho.textoAjuda = this.elementoFilhoOriginal.textoAjuda
                        this.elementoFilho.editavel = false

                        this.$emit('redirecionamento', {redirecionamento: campoFilho.redirecionamento})
                        return false
                    }

                if(campoFilho) {
                    this.elementoFilho.cdServico             = campoFilho.cdServico
                    this.elementoFilho.cdTpUsoCampoGuia      = campoFilho.cdTpUsoCampoGuia
                    this.elementoFilho.cdValidacao           = campoFilho.cdValidacao
                    this.elementoFilho.codigo                = campoFilho.codigo
                    this.elementoFilho.descTpCampoGuia       = campoFilho.descTpCampoGuia
                    this.elementoFilho.descTpDado            = campoFilho.descTpDado
                    this.elementoFilho.formato               = campoFilho.formato                    
                    this.elementoFilho.idTpUsoCampoGuiaRegra = campoFilho.idTpUsoCampoGuiaRegra
                    this.elementoFilho.indSituacao           = campoFilho.indSituacao
                    this.elementoFilho.label                 = campoFilho.label
                    this.elementoFilho.msgTamMaximo          = campoFilho.msgTamMaximo
                    this.elementoFilho.msgTamMinimo          = campoFilho.msgTamMinimo
                    this.elementoFilho.msgTamMinimoMaximo    = campoFilho.msgTamMinimoMaximo
                    this.elementoFilho.nomeCampo             = campoFilho.nomeCampo
                    this.elementoFilho.sigla                 = campoFilho.sigla
                    this.elementoFilho.tamMaximo             = campoFilho.tamMaximo
                    this.elementoFilho.tamMinimo             = campoFilho.tamMinimo                    
                    this.elementoFilho.tamanhoFixo           = campoFilho.tamanhoFixo
                    this.elementoFilho.textoAjuda            = campoFilho.textoAjuda
                    this.elementoFilho.tpDado                = campoFilho.tpDado
                    this.elementoFilho.tpUsoCampoGuia        = campoFilho.tpUsoCampoGuia
                    this.elementoFilho.editavel              = true
                    this.elementoFilho.visivelPadrao         = campoFilho.abrirCampo                    
                    this.setarMascaraDoFilho(this.elementoFilho)
                }

            }
        },
        buscarFilho() {
            this.elementoFilho = this.lstCampos.find((e) => (this.campo.idParametCampoGuiaCruzada == e.idParametCampoGuia))
            this.elementoFilhoOriginal = _.cloneDeep(this.elementoFilho)
            // buscar o indice o filho no validador
            for(let i = 0; i < this.passo.data.lstCampos.length; i++) {                
                if(this.v?.passos?.$each[this.indicePassos]?.data?.lstCampos?.$each[this.idx].$model.idParametCampoGuiaCruzada
                    == this.v?.passos?.$each[this.indicePassos]?.data?.lstCampos?.$each[i].$model.idParametCampoGuia) {                
                    this.indiceValidadorFilho = i
                    this.elementoFilho.editavel = false
                    break;
                }
            }
        },
        setarMascaraDoFilho(campo) {
            if(campo.tpDado == this.tipoEnum.NUMERICO) {            
                if(campo.formato.length == 0) {
                    campo.formato = this.mascaraTipoNumerico.padEnd(campo.tamMaximo, '#')
                }
            }
        },
        eventoInputComboBox() {
            if(this.elementoFilho) {
                this.elementoFilho.valorFormatado = ''
                this.elementoFilho.lstErros = []
            }
        },
        situacaoInexistente() {
            this.$emit('situacaoInexistente')
            return true
        },
        preencherComZeros() {
            if(this.campo.valorFormatado.length && [1, 2, 3].includes(this.campo?.tpUsoCampoGuia)) {
                this.campo.valorFormatado = this.campo.valorFormatado
                                            .replace(/[^a-zA-Z0-9]+/g, '')
                                            .padStart(this.campo.tamMaximo, '0')
                console.log('this.campo : ', this.campo)
            }
        },
        blurInput(v) {
            v.$touch()
            let pending = v.$pending
        },
        inputInput(v) {
            v.$model.lstErros = []
            v.$reset()
        },
        setMultiplasMascaras() {
            // Mascaras para telefone
            if(this.campo.cdCampoGuia == 17)
                this.multiplasMascaras = ['(##) ####-####', '(##) #####-####']
        }
    }
}
</script>
<style>
</style>